import {Injectable} from '@angular/core';
import {BaseService} from "./base.service";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";
import {GlobalService} from "./global.service";
import {Observable} from "rxjs";
import {AppUrl} from "../constants/app-url";

@Injectable({
  providedIn: 'root'
})
export class BookService extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  add(data: {}): Observable<any> {
    return this.postRequest(AppUrl.BOOK(), data);
  }

  get(data: {}): Observable<any> {
    return this.getRequest(AppUrl.BOOK(), data);
  }

  getBookSearch(data: {}): Observable<any> {
    return this.getRequest(AppUrl.BOOK_SEARCH(), data);
  }
  count(data: {}): Observable<any> {
    return this.getRequest(AppUrl.BOOK_COUNT(), data);
  }

  detail(uniqueId: any): Observable<any> {
    return this.getRequest(AppUrl.BOOK(uniqueId));
  }

  update(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.BOOK(uniqueId), data);
  }

  updateBookCoverImage(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.BOOK_COVER_IMAGE(uniqueId), data);
  }

  status(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.BOOK_STATUS(uniqueId), data);
  }

  delete(uniqueId: any): Observable<any> {
    return this.deleteRequest(AppUrl.BOOK(uniqueId));
  }

  deleteImage(id: any): Observable<any> {
    return this.deleteRequest(AppUrl.BOOK_IMAGE(id));
  }

  searchByIsb(data: {}): Observable<any> {
    return this.getRequest(AppUrl.BOOK_BY_ISBN(), data);
  }
  downloadBooksData(data: {}): Observable<any> {
    return this.getRequest(AppUrl.DOWNLOAD_BOOK_DATA(), data);
  }
}
